<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		title?: string;
		loading?: boolean;
		error?: string | null;
		empty?: boolean;
		emptyMessage?: string;
		currentPage?: number;
		totalPages?: number;
		skeletonCount?: number;
	}>(),
	{
		title: '',
		loading: false,
		error: null,
		empty: false,
		emptyMessage: 'Nessun elemento disponibile.',
		currentPage: 1,
		totalPages: 1,
		skeletonCount: 3,
	},
);

const emit = defineEmits<{
	'prev-page': [];
	'next-page': [];
}>();

const showPagination = computed(
	() => props.totalPages > 1 && !props.loading && !props.error && !props.empty,
);
</script>

<template>
	<section class="bg-white border border-gray-200 shadow-sm rounded-none px-5 py-5">
		<div v-if="loading" class="space-y-3">
			<div
				v-for="n in skeletonCount"
				:key="n"
				class="border border-gray-100 px-4 py-3 animate-pulse bg-gray-50 rounded-none"
			>
				<div class="h-3 w-32 bg-gray-200 rounded mb-2" />
				<div class="h-3 w-24 bg-gray-100 rounded mb-1" />
				<div class="h-3 w-40 bg-gray-100 rounded" />
			</div>
		</div>
		<div
			v-else-if="error"
			class="border border-red-200 text-red-700 px-4 py-3 text-sm bg-red-50 rounded-none"
		>
			{{ error }}
		</div>
		<div
			v-else-if="empty"
			class="border border-gray-200 px-4 py-3 text-sm text-gray-500 bg-gray-50 rounded-none"
		>
			{{ emptyMessage }}
		</div>
		<div v-else class="space-y-3">
			<slot />
			<div
				v-if="showPagination"
				class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-3 border-t border-gray-100 mt-2 text-xs sm:text-sm text-gray-600"
			>
				<p>
					Pagina {{ currentPage }} di {{ totalPages }}
				</p>
				<div class="flex items-center gap-2">
					<button
						type="button"
						class="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 bg-white text-xs sm:text-sm uppercase font-button disabled:opacity-50 disabled:cursor-not-allowed rounded-none"
						:disabled="currentPage === 1"
						@click="emit('prev-page')"
					>
						<span class="material-symbols-outlined text-sm sm:text-base">chevron_left</span>
						Precedente
					</button>
					<button
						type="button"
						class="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 bg-white text-xs sm:text-sm uppercase font-button disabled:opacity-50 disabled:cursor-not-allowed rounded-none"
						:disabled="currentPage === totalPages"
						@click="emit('next-page')"
					>
						Successiva
						<span class="material-symbols-outlined text-sm sm:text-base">chevron_right</span>
					</button>
				</div>
			</div>
		</div>
	</section>
</template>
